import React from 'react';
import useTheme from '../hooks/useTheme';
export default function withTheme(Component) {
    const WithThemeComponent = (props) => {
        const [{ theme }] = useTheme();
        return React.createElement(Component, { ...props, theme: theme });
    };
    return WithThemeComponent;
}
